import uuid from 'uuid/v4';
import { createAction } from 'redux-actions';
import {
  getValueFromObjects,
  getCPRMapping,
  createParams,
  validateParams,
  getLeadDescription,
  getLeadProductDetails,
  getLeadSource,
} from './common';
import Product from './product';
import * as types from '../../constants/Api';
import { createErrorBody } from '../error';
import { appErrorAction } from '../../actions/App';

class LeadService extends Product {
  static CREATE_LEAD = 'lead/v1/create';
  static leadCreate = createAction(types.LEAD_CREATE);
  static leadCreated = createAction(types.LEAD_CREATED)
  constructor() {
    super(
      LeadService.leadCreate
    );
    super.prepareCreateUpdateResponse = this.prepareCreateUpdateResponse;
  }

  generateLeadAction() {
    return (dispatch) =>
      dispatch(LeadService.leadCreate());
  }

  generatedLeadAction(payload) {
    return dispatch =>
      dispatch(LeadService.leadCreated(payload));
  }

  createLead(params, values) {
    return (dispatch, getState) => {
      const state = getState();
      const formValues = { ...values, ...state.userData };
      const mappedParams = params ? createParams(params, formValues, state) : {};
      const errors = params ? validateParams(mappedParams, params) : [];

      if (errors.length > 0) {
        return Promise.reject(createErrorBody('Missing parameters', errors));
      }

      const custName = getValueFromObjects('firstName', mappedParams, formValues) + getValueFromObjects('lastName', mappedParams, formValues) || '';
      const custAddress = getValueFromObjects('street', mappedParams, formValues) + getValueFromObjects('houseNumber', mappedParams, formValues) || '';
      const requestModel = {
        general: {
          globalTransactionId: uuid(),
        },
        customer: {
          cpr: getCPRMapping(mappedParams, formValues),
          name: custName,
          address: custAddress,
          city: getValueFromObjects('city', mappedParams, formValues),
          postalCode: getValueFromObjects('postalCode', mappedParams, formValues),
          emailAddress: getValueFromObjects('emailAddress', mappedParams, formValues),
          mobilePhoneNumber: getValueFromObjects('telephoneNumber', mappedParams, formValues),
          countryCode: getValueFromObjects('countryCode', mappedParams, formValues),
          customerType: '',
          ePermission: '',
          interestedIn: '',
        },
        leadDescription: getLeadDescription(mappedParams, formValues),
        product: getLeadProductDetails(mappedParams, formValues),
        source: getLeadSource(mappedParams, formValues),
      };

      this.generateLeadAction();
      return this.callApiPost(LeadService.CREATE_LEAD,
        requestModel, dispatch)
        .then((data) => {
          dispatch(this.generatedLeadAction());
          return data;
        })
        .catch(data => {
          dispatch(appErrorAction(data));
          return Promise.reject(data);
        });
    };
  }
}

export const leadService = new LeadService();
